import { combineReducers } from 'redux';
import FireBaseUserReducer from './firebase_user_reducer';
import DriverProfileReducer from './driver_profile_reducer';
import CityOptionsReducer from './city_options_reducer';
import CarsReducer from './cars_reducer';
import NewCarReducer from './new_car_reducer';
import FuelRecordsReducer from './fuel_records_reducer';
import OneFuelRecordReducer from './one_fuel_record_reducer'
import UsersReducer from './users_reducer';

const rootReducer = combineReducers({
    currentUser: FireBaseUserReducer,
    driverProfile: DriverProfileReducer,
    cityOptions: CityOptionsReducer,
    cars: CarsReducer,
    newCar: NewCarReducer,
    fuelRecords: FuelRecordsReducer,
    oneFuelRecord: OneFuelRecordReducer,
    users: UsersReducer,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/app/reducers/index.js